import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getBaseUrl } from '@/redux/modules/config';

type Props = {
    catalogId: number;
};

const AuctionVideoPageHeaderMeta = ({ catalogId }: Props) => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const pageTitle = useAddNotificationCountToTitle(formatMessage({ id: 'bidding_console.video.title' }, { title }));
    const description = formatMessage({ id: 'bidding_console.video.description' }, { title });
    const canonical = `${baseUrl}/video/${catalogId}`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={pageTitle}
        />
    );
};

export default AuctionVideoPageHeaderMeta;
